/* eslint-disable @typescript-eslint/no-explicit-any */
// RequireAuth.tsx
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getUserAuth } from '../reducers/User/actions';
import AppLayout from '../components/AppLayout';
import CheckPermission from './CheckPermission';

interface Props {
  children: React.ReactNode;
  noLayout?: boolean;
}

const RequireAuth: React.FC<Props> = ({ children, noLayout = false }) => {
  const isAuthenticated = useSelector(getUserAuth);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return noLayout ? (
    <CheckPermission>{children}</CheckPermission>
  ) : (
    <AppLayout>
      <CheckPermission>{children}</CheckPermission>
    </AppLayout>
  );
};

export default RequireAuth;
